import { Fragment, type ReactElement } from "react";
import { Navigate, Route, useLocation, useParams } from "react-router-dom";
import { routes } from "routing";
import { LEGACY_EDIT_REDIRECTS } from "routing/legacyEditPaths";

function LegacyRedirect({ to }: { to: string }) {
  const { search, hash, state } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} state={state} replace />;
}

const SectionRedirect = () => {
  const { sectionID, idItem, idSubPage, idSubItem } = useParams();
  const { search, state } = useLocation();
  const to = idSubItem
    ? routes.edit.sectionItemPageItem.build({
        sectionId: sectionID!,
        itemId: idItem!,
        pageId: idSubPage!,
        subItemId: idSubItem,
      })
    : idSubPage
      ? routes.edit.sectionItemPage.build({ sectionId: sectionID!, itemId: idItem!, pageId: idSubPage })
      : idItem
        ? routes.edit.sectionItem.build({ sectionId: sectionID!, itemId: idItem })
        : routes.edit.section.build({ sectionId: sectionID! });
  return <Navigate to={`${to}${search}`} state={state} replace />;
};

const TransportItemRedirect = () => {
  const { idItem } = useParams<{ idItem: string }>();
  const { search, state } = useLocation();
  return <Navigate to={`${routes.edit.transportItem.build({ itemId: idItem! })}${search}`} state={state} replace />;
};

const ActivityItemRedirect = () => {
  const { idItem } = useParams<{ idItem: string }>();
  const { search, state } = useLocation();
  return <Navigate to={`${routes.edit.activityItem.build({ itemId: idItem! })}${search}`} state={state} replace />;
};

const TodoItemRedirect = () => {
  const { idItem } = useParams<{ idItem: string }>();
  const { search, state } = useLocation();
  return <Navigate to={`${routes.edit.todoItem.build({ itemId: idItem! })}${search}`} state={state} replace />;
};

const HotelManageRedirect = () => {
  const { idItem } = useParams<{ idItem: string }>();
  const { search, state } = useLocation();
  return <Navigate to={`${routes.edit.hotelManage.build({ itemId: idItem! })}${search}`} state={state} replace />;
};

export function legacyEditRedirects(): ReactElement {
  return (
    <Fragment>
      {LEGACY_EDIT_REDIRECTS.map(([from, to]) => (
        <Route key={from} path={from} element={<LegacyRedirect to={to} />} />
      ))}
      <Route path="/edit/Section/:sectionID" element={<SectionRedirect />} />
      <Route path="/edit/Section/:sectionID/:idItem" element={<SectionRedirect />} />
      <Route path="/edit/Section/:sectionID/:idItem/:idSubPage" element={<SectionRedirect />} />
      <Route path="/edit/Section/:sectionID/:idItem/:idSubPage/:idSubItem" element={<SectionRedirect />} />
      <Route path="/edit/transport/list/:idItem" element={<TransportItemRedirect />} />
      <Route path="/edit/activities/general/:idItem" element={<ActivityItemRedirect />} />
      <Route path="/edit/activities/todos/:idItem" element={<TodoItemRedirect />} />
      <Route path="/edit/hotelbooking/manage/:idItem" element={<HotelManageRedirect />} />
    </Fragment>
  );
}
